import { createFileRoute } from "@tanstack/react-router";
import { AdminUsersPage } from "@/features/admin/users";

export const Route = createFileRoute("/admin/users")({
  head: () => ({ meta: [{ title: "Users · Admin · Malfak" }] }),
  component: AdminUsersPage,
});
